import DateCellRenderer from '../../../sharedmodules/grid-cell-renderer/date-cell-renderer';
import classNames from '../../../sharedmodules/constants/ag-grid-class-names';
import dateFilterParams from '../../../sharedmodules/constants/date-filter-params';
import { translate } from '../../../sharedmodules/services/translation-service';

export const getUserDealerColumnDefinitions = () => [
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'userId',
        field: 'userId',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('USER_ID'),
        filterParams: {
            suppressAndOrCondition: true,
        },
        width: 200,
    },
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'dealerAccount',
        field: 'dealerAccount',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('DEALER_ACCOUNT'),
        filterParams: {
            suppressAndOrCondition: true,
        },
        width: 200,
    },
    // {
    //     cellClass: classNames.cellLeftClassName,
    //     colId: 'selected',
    //     field: 'selected',
    //     headerClass: classNames.headerLeftClassName,
    //     headerName: translate('SELECTED'),
    //     filterParams: {
    //         suppressAndOrCondition: true,
    //     },
    //     width: 200,
    // },
    // {
    //     cellClass: classNames.cellLeftClassName,
    //     colId: 'registrationAllowed',
    //     field: 'registrationAllowed',
    //     headerClass: classNames.headerLeftClassName,
    //     headerName: translate('REGISTRATION_ALLOWED'),
    //     filterParams: {
    //         suppressAndOrCondition: true,
    //     },
    //     width: 200,
    // },
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'delearCity',
        field: 'delearCity',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('DEALER_CITY'),
        filterParams: {
            suppressAndOrCondition: true,
        },
        width: 200,
    },
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'delearState',
        field: 'delearState',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('DEALER_STATE'),
        filterParams: {
            suppressAndOrCondition: true,
        },
        width: 200,
    },
    {
        cellClass: classNames.cellLeftClassName,
        colId: 'delearCountry',
        field: 'delearCountry',
        headerClass: classNames.headerLeftClassName,
        headerName: translate('DELAER_COUNTRY'),
        filterParams: {
            suppressAndOrCondition: true,
        },
        width: 200,
    },
    {
        cellClass: classNames.cellClassName,
        cellRendererFramework: DateCellRenderer,
        colId: 'lastRBACDate',
        field: 'lastRBACDate',
        filter: 'date',
        headerClass: classNames.headerClassName,
        filterParams: dateFilterParams,
        headerName: translate('LAST_UPDATE_DATE'),
        width: 150,
    },
];
